export default __webpack_public_path__ + "static/media/tik.177edaba.svg";